import { useSnapshot } from '@framework/hooks/useSnapshot';
import { RTDBPath } from 'balus-common';
import type { GroupId, UserId } from 'balus-common';

/**
 * 指定のグループに所属するメンバーのユーザID一覧を配列で返します。
 * 取得完了までの間は undefined を返します。
 * ゲストユーザを除外したい場合には excludeGuest に true を設定してください。
 * @param groupId
 * @returns
 */
export const useGroupMemberUserIds = (groupId: GroupId, options?: { excludeGuest: boolean }): UserId[] | undefined => {
  const [userIds, { loading }] = useSnapshot<UserId[]>({
    path: RTDBPath.Group.memberRolesPath(groupId),
    load: ({ snapshot }) => {
      return Object.entries(snapshot.val() || {})
        .filter(([, role]) => (options?.excludeGuest ? role !== 'guest' : true))
        .map(([userId]) => userId)
        .sort();
    },
  });

  return loading ? undefined : userIds || [];
};
